import { gql } from '@apollo/client'

export const getAddressByDoorIdQuery = gql`
  query getAddressByDoorIdQuery($doorId: String!) {
    addressByDoorId(doorId: $doorId) {
      address_line_1
      address_line_2
      city
      state_abv
      state
      country_code
      county
      postal_code
    }
  }
`

export const getAddressByPersonIdQuery = gql`
  query getAddressByPersonId($personId: String!, $addressTypeId: String!) {
    addressByPersonId(personId: $personId, addressTypeId: $addressTypeId) {
      address_line_1
      address_line_2
      city
      state_abv
      state
      country_code
      county
      postal_code
    }
  }
`
